
import { onDomReady } from "../services/on-dom-ready";
import ModalBlocked from "../components/modal/modal-blocked";
import AjaxForm from "../components/ajax-form";
import { initLoader } from "./init-loader-button";
import Toast from "../components/modal/toast";

const initForm = (form, onSubmit) => {
  new AjaxForm(form, {
    afterSubmit: () => {
      onSubmit();
      Toast.open('Ваше сообщение отправлено', {
        state: "success"
      });
      form.reset();
    },
    onError: (error) => {
      console.error(error);
      Toast.open(error, { state: "error" });
    }
  });

  initLoader(form);
}

const bugPopupPromise = new Promise((resolve, reject) => {
  onDomReady.then(() => {
    let element = document.getElementById("bugs");
    if (element) {
      let popup = ModalBlocked.get(element);

      let form = element.querySelector("form");
      initForm(form, () => {
        popup.close();
      });

      resolve(popup);
    } else {
      reject("There is no #bugs element on page");
    }
  });
});

const bugReport = () => {
  return new Promise((resolve, reject) => {
    bugPopupPromise
      .then(popup => {
        popup.open();
      });

  });
};

export { bugReport };